import { render, staticRenderFns } from "./ConfirmCommunicationRestored.vue?vue&type=template&id=2e39723d&scoped=true&"
import script from "./ConfirmCommunicationRestored.vue?vue&type=script&lang=ts&"
export * from "./ConfirmCommunicationRestored.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e39723d",
  null
  
)

export default component.exports